import { createAsyncThunk } from '@reduxjs/toolkit'
import MediationStep from './mediation-step-model'
import {
  delete_mediationStep,
  load_mediationSteps,
  store_mediationStep,
} from './mediationStep-service'

export const LoadMediationStepsAsync = createAsyncThunk<any, any>(
  'composer/load/mediationStep',
  async (params: { uid: string }) => {
    return await load_mediationSteps(params)
  },
)

export const CreateMediationStepAsync = createAsyncThunk<any, any>(
  'composer/create/mediationStep',
  async (params: MediationStep) => {
    return await store_mediationStep(params)
  },
)

export const DeleteMediationStepAsync = createAsyncThunk<any, any>(
  'composer/delete/mediationStep',
  async (params) => {
    return await delete_mediationStep(params)
  },
)
